export default __webpack_public_path__ + "static/media/DataForYou.f8352c66bfb7b0843c31212c5a1484a5.webp";